module.exports = __webpack_public_path__ + "static/media/027-man-7.8fe960d0.svg";